import { render, staticRenderFns } from "./FormsTab.vue?vue&type=template&id=d74e5390"
import script from "./FormsTab.vue?vue&type=script&lang=js"
export * from "./FormsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports